import { useEffect, useState } from "react";
import Layout from "../components/Layouts/Layout";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import HumanResource from "../components/HumanResource";
import Jobs from "./Jobs";
import JobsSmall from "./job/JobsSmall";
function Sales() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(3);
  const [selectedNews, setSelectedNews] = useState();
  const [news, setNews] = useState([]);
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/v1/News/getNews`, {
        headers: {
          "Content-Type": "applicaiton/json",
        },
      })
      .then((res) => {
        let pre3 = [];
        for (let index = 0; index < res.data.news.length; index++) {
          const element = res.data.news[index];
          if (element.newsType == selected) {
            pre3.push(element);
          }
        }
        setNews(pre3);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, [selected]);
  const handleOpen = (item) => setSelectedNews(item);
  const handleClose = () => setSelectedNews(null);
  return (
    <Layout>
      {loading ? (
        <div className="body">
          <div className="main min-h-[calc(100vh-60px)] pt-3 flex justify-center items-center ">
            <Spinner animation="border" role="status" variant="danger">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <div className="h-full relative bg-white">
          <div className="body">
            <div className="main min-h-[calc(100vh-380px)]">
              <div className="container ">
                <div className="row mt-14">
                  <div className="col-md-3">
                    <div className="content">
                      <div
                        onClick={() => {
                          setSelected(3);
                        }}
                        className={`border-b  border-t  ${
                          selected === 3 && "!bg-gray-100 text-red-500"
                        } p-3 nunito-400 text-[14px] text-gray-500 hover:bg-gray-50 select-none cursor-pointer rounded`}
                      >
                        Бетон зуурмаг
                      </div>
                      <div
                        onClick={() => {
                          setSelected(4);
                        }}
                        className={`border-b ${
                          selected === 4 && "!bg-gray-100 text-red-500"
                        } p-3 nunito-400 text-[14px] text-gray-500 hover:bg-gray-50 select-none cursor-pointer rounded`}
                      >
                        Шатахуун
                      </div>
                      <div
                        onClick={() => {
                          setSelected(5);
                        }}
                        className={`border-b ${
                          selected === 5 && "!bg-gray-100 text-red-500"
                        } p-3 nunito-400 text-[14px] text-gray-500 hover:bg-gray-50 select-none cursor-pointer rounded`}
                      >
                        Орон сууц
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    {news.map((item, index) => (
                      <div
                        key={index}
                        className="cursor-pointer nunito-300 text-[14px] min-h-[400px] mb-8 hover:bg-gray-100 p-3 rounded-lg transition"
                        onClick={() => handleOpen(item)}
                      >
                        <img
                          src={item.imgPath} // or item.image, depending on your object field
                          alt={item.title}
                          className="w-80% h-auto rounded-lg mb-3 object-cover"
                        />
                        <h6 className="nunito-400 mb-3 font-[900] text-[20px] mt-2 md:mt-0">
                          {item.title}
                        </h6>
                        <p className="nunito-300 text-justify mt-2">
                          {item.newsBody}
                        </p>
                      </div>
                    ))}
                  </div>
                  {selectedNews && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div className="bg-white rounded-2xl shadow-lg p-6 w-[90%] md:w-[600px] relative">
                        {/* Close button */}
                        <button
                          onClick={handleClose}
                          className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
                        >
                          ✕
                        </button>

                        {/* Image */}
                        <img
                          src={selectedNews.imgPath}
                          alt={selectedNews.title}
                          className="w-full h-[300px] object-cover rounded-lg mb-4"
                        />

                        {/* Title */}
                        <h2 className="text-2xl font-bold mb-2">
                          {selectedNews.title}
                        </h2>

                        {/* Description */}
                        <p className="text-gray-600 mb-2">
                          {selectedNews.description}
                        </p>

                        {/* News body */}
                        <p className="text-gray-800 whitespace-pre-line">
                          {selectedNews.newsBody}
                        </p>

                        {/* Date */}
                        <div className="text-sm text-gray-400 mt-4">
                          {selectedNews.createdDate}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default Sales;
